const FormResources = {

    form_data:{
        date: '',
        search: '',
        beds: [],
    },

    form_format:[
        {
            css_class:  'col-md-12',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12 mt-3',
            type:       'select-multiple',
            maxlength:  10,
            disabled:   false,
            step:       '',
            name:       'Bed codes:',
            model_name: 'bed_vacant_id',
            ref:        'bed_vacant_id_input',
            ref_alt:    'bed_vacant_id_input_alt',
            required:   true,
        },
    ],

    form_format_edition:[
        {
            css_class:  'col-md-6',
            type:       'date',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Date:',
            model_name: 'date',
            ref:        'date_input',
            ref_alt:    'date_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'select-multiple',
            maxlength:  10,
            disabled:   false,
            step:       '',
            name:       'Bed codes:',
            model_name: 'bed_vacant_id',
            ref:        'bed_vacant_id_input',
            ref_alt:    'bed_vacant_id_input_alt',
            required:   true,
        },
    ],
}

export default FormResources;